import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getSectionsList = async () => {
  return await axiosInstance.get("sections/getlist", { headers });
};

export const getSectionById = async (id) => {
  const response = await axiosInstance.get(`sections/get/${id}`, { headers });
  return response.data.result;
};

export const addSection = async (payload) => {
  return await axiosInstance.post("sections/add", payload, { headers });
};

export const updateSection = async (payload) => {
  return await axiosInstance.put("sections/update", payload, { headers });
};

export const deleteSection = async (id) => {
  return await axiosInstance.delete(`sections/delete/${id}`, { headers });
};
